import {SelectBox} from "pages/common/SelectBox"
import {useCallback, useEffect, useState} from "react"
import {Role} from "dto/Role"
import {useFindAllRoles} from "hooks/query/role-query"
import {useParams} from "react-router-dom"
import {NotificationType, showNotification} from "common/Notification"
import {
    useAssignRoleToUser,
    useFindUserAvailableRoles,
    useFindUserRolesById,
    useRemoveRoleFromUser
} from "hooks/query/user-query"

export function UpdateUserRoleMapping() {
    const {id} = useParams()
    const {data: roles} = useFindUserAvailableRoles(id)
    const {data: userRoles} = useFindUserRolesById(id)
    const updateRoleMappingMutate = useAssignRoleToUser()
    const removeRoleMappingMutate = useRemoveRoleFromUser()
    const [sourceItem, setSourceItem] = useState<Role | undefined>()
    const [targetItem, setTargetItem] = useState<Role | undefined>()
    const [sourceList, setSourceList] = useState<Role[]>([])
    const [targetList, setTargetList] = useState<Role[]>([])


    console.log("user role", userRoles)
    useEffect(() => {
        setSourceList(roles || [])
    }, [roles])
    useEffect(() => {
        setTargetList(userRoles || [])
    }, [userRoles])


    const addRole = useCallback(() => {
        if (!sourceItem || !id) {
            showNotification("선택한 Role이 없습니다")
            return
        }
        updateRoleMappingMutate.mutate({id, roleName: sourceItem.name}, {
            onSuccess: () => showNotification("추가하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("추가하지 못했습니다")
        })
    }, [id, sourceItem, updateRoleMappingMutate])
    const removeRole = useCallback(() => {
        if (!targetItem || !id) {
            showNotification("선택한 Role이 없습니다")
            return
        }
        removeRoleMappingMutate.mutate({id, roleName: targetItem.name}, {
            onSuccess: () => showNotification("삭제하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("삭제하지 못했습니다")
        })
    }, [id, removeRoleMappingMutate, targetItem])
    console.log("sourceItem: ", sourceItem)
    return (
        <div className="columns mt20">
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">사용가능한 Roles</div>
                    <SelectBox items={sourceList || []} onChangeItem={(item) => setSourceItem(item)}
                               themeColor="green"/>
                    <div className="mt10">

                        <div className="is-clickable button is-success is-size-85" onClick={() => addRole()}>
                            <span>선택추가</span>
                            <span className="icon">
                                <i className="fa-solid fa-angles-right"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">선택된 Roles</div>
                    <SelectBox items={targetList || []} onChangeItem={(item) => setTargetItem(item)} themeColor="blue"/>
                    <div className="mt10">
                        <div className="is-clickable button is-info is-size-85" onClick={() => removeRole()}>
                            <span className="icon">
                                <i className="fa-solid fa-angles-left"></i>
                            </span><span>선택삭제</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}